import { createContext } from 'react';

export const FormsNavigationContext = createContext<
  { prev: () => void; next: () => void } | undefined
>(undefined);
